import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CustomCheckbox, CustomDataTableHeader } from '../../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../../store/actions/system.actions'
import ModalCliente from '../../../../Cadastros/Cliente/ModalCliente/ModalCliente'
import useClienteSemCoordenada, { LOAD_MESSAGE } from './ClienteSemCoordenadaHook'

function ClienteSemCoordenada({ dispatch, customers, onSave }) {
  const { state, localDispatch } = useClienteSemCoordenada()

  useEffect(() => {
    localDispatch.onInit(customers)
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.UPDATE_CUSTOMER:
        onSave(state.updatedCustomer)
        localDispatch.resetState()
        break

      case LOAD_MESSAGE.FIND_ALL_COORDINATES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.findAllCoordinates(state.customers)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  return (
    <>
      {state.customers.length > 0 && (
        <div
          className="p-col-12"
          style={{ display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 0 }}
        >
          <span>Encontrar as coordenadas para todos os clientes: </span>
          <Button
            icon="pi pi-map-marker"
            label={'Encontrar'}
            style={{ backgroundColor: '#14B0BF', height: 30 }}
            onClick={localDispatch.onFindAllClicked}
          />
        </div>
      )}
      <div className="p-col-12" style={{ height: 500 }}>
        <DataTable
          value={state.customers}
          selectionMode={'single'}
          paginator={true}
          rows={10}
          header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
          globalFilter={state.globalFilter}
          emptyMessage={'Todos os clientes possuem coordenadas.'}
          onRowClick={e => localDispatch.onRowClicked(e.data)}
        >
          <Column field="nomeFantasia" header="Nome Fantasia" />
          <Column field="district" header="Bairro" />
          <Column field="address" header="Endereço" />
          <Column field="number" header="Número" />
          <Column
            field="actived"
            header="Ativo"
            style={{ textAlign: 'center', width: 100 }}
            body={(rowData, column) => (
              <CustomCheckbox disabled checked={Boolean(rowData.actived)} />
            )}
          />
        </DataTable>
      </div>
      <ModalCliente
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        selectedCliente={state.selectedCustomer}
        show={state.showModal}
      />
    </>
  )
}

export default connect()(ClienteSemCoordenada)
